<template>
  <teleport to="#app">
    <div
      v-if="value !== null"
      ref="symbolPicker"
      class="symbolpicker-popout"
      v-bind="$attrs"
      :style="{ left: x + 'px', top: y + 'px' }"
    >
      <button
        v-for="symbol in symbolLibrary"
        :key="symbol"
        type="button"
        class="button-icon symbolpicker-popout__button"
        @click="chooseSymbol(symbol)"
      >
        <svg-symbol :name="symbol" />
      </button>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";

import { onPointerDownOutside } from "@core/composables/onMouseDownOutside";
import { symbolLibrary } from "@core/ui/symbols";

import SvgSymbol from "./SvgSymbol.vue";

import type { IconSymbol } from "@core/ui/symbols";

defineOptions({
  inheritAttrs: false
});

interface Props {
  value: string | null;
  x?: number;
  y?: number;
}
withDefaults(defineProps<Props>(), {
  x: 0,
  y: 0
});

const emit = defineEmits<{
  (e: "update:value", value: IconSymbol): void;
  (e: "close"): void;
}>();

const symbolPicker = ref<HTMLElement>();

let unbindCancel: (() => void) | null = null;

onMounted(() => {
  unbindCancel = onPointerDownOutside([symbolPicker], () => {
    close();
  });
});
onUnmounted(() => {
  if (unbindCancel) {
    unbindCancel();
    unbindCancel = null;
  }
});

function chooseSymbol(symbol: IconSymbol) {
  emit("update:value", symbol);
  close();
}

function close() {
  emit("close");
}
</script>

<style lang="scss">
.symbolpicker-popout {
  position: fixed;
  z-index: 5;
  background-color: var(--color-background-close);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  min-height: 3rem;
  min-width: 2.4rem;
  display: flex;
  flex-direction: column;
  font-size: 20px;

  &__button {
    font-size: 1em;
    padding: 0.5em 0;
  }
}
</style>
